import script from "./Announcements.vue?vue&type=script&lang=ts&setup=true"
export * from "./Announcements.vue?vue&type=script&lang=ts&setup=true"

import "./Announcements.vue?vue&type=style&index=0&id=6c8ddd60&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c8ddd60"]])

export default __exports__